import styled from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';
import { GRID } from '~/common/layout-propertis/grid';

export const StyContainer = styled.div`
  min-height: 100%;
  width: 100%;
  display: flex;
  background: ${({ theme }) => theme.neutral[950]};
`;

export const StyWrapper = styled.div`
  min-height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 1;
  padding: ${SPACING._48} ${SPACING._32};

  @media ${GRID._SM} {
    padding: ${SPACING._48} ${SPACING._24};
  }

  @media ${GRID._XS} {
    padding: ${SPACING._48} ${SPACING._24};
  }
`;

export const StyLogoImage = styled.div`
  width: 100%;
`;

export const StyContent = styled.div`
  display: flex;
  overflow-y: auto;
  overflow-x: hidden;
  padding: ${SPACING._32} 0;
  flex-direction: column;
  gap: ${SPACING._24};
  width: 370px;
  max-width: 100%;
  height: 100%;
  justify-content: center;
`;

export const StyFooter = styled.div`
  width: 370px;
  max-width: 100%;
  display: flex;
  justify-content: space-between;
  flex-flow: wrap;
  gap: ${SPACING._8};

  > span {
    font-size: 10px;
  }
`;

export const StyLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING._8};
  align-items: start;
  width: 100%;
`;

export const StyPrivacity = styled.div`
  display: flex;
  cursor: pointer;
  &:hover {
    span {
      text-decoration: underline;
    }
  }
`;
